import React, { useCallback, useEffect, useState } from "react";
import {
  Tabs,
  Modal,
  Button,
  Switch,
  Input,
  Checkbox,
  Radio,
  Tag,
  message,
  Select,
  List,
  Typography,
  notification,
} from "antd";
import {
  BellOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  SyncOutlined,
  BgColorsOutlined,
} from "@ant-design/icons";
import {
  ColorLensOutlined,
  RepeatOutlined,
  RepeatOn,
  AssignmentOutlined,
} from "@mui/icons-material";
import "../../App.css";
import eventicon from "../../Assets/calender/Event-icon.png";
import taskicon from "../../Assets/calender/Task-icon.png";
import TimeSelect from "../CalenderModal/TimeSelect";
import Reminder from "../CalenderModal/Reminder";
import { URL } from "../../helper/Mainurl";
import FloatLabel from "../FloatLabel";
import ChecklistComponent from "../ChecklistComponent";
import DetailsList from "../DetailsList";
import "../CalenderModal/FilterModal.css";
import "./AddCoParentTask.css";
import DateModalTask from "../CalenderModal//DateModalTask";
import moment from "moment";
import AssignToModal from "./AssignCoParentToModal";
import CollaborationModal from "./CollaborationCoParentModal";
import RepeatModal from "./RepeatModalCoParent";
import ColorsModal from "./ColorsModalCoParent";
import { Color } from "antd/es/color-picker";
import RecurringEventModal from "../../Components/Modals/DeleteAndUpdateModal/DeleteAndUpdateModal";
import { assign, set } from "lodash";
import DeleteConfirmationModal from "../DeleteConfirmationModal";

const { Title, Text, Paragraph } = Typography;
const ViewCoParentTask = ({
  isModalOpen,
  closeModal,
  couples,
  allChildren,
  eventData,
  metaData,
  calenderMetaData,
  onTaskUpdate,
  calendarData,
  coParentsMetaData,
}) => {
  const token = localStorage.getItem("authToken"); // Get token from localStorage
  const [progressStatus, setProgressStatus] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [assignName, setAssignName] = useState("");
  const [collaboratorsName, setCollaboratorsName] = useState([]);
  const [activeTab, setActiveTab] = useState(() => {
    return eventData.type === "task" ? "1" : "2"; // Default to "1" for task, "2" for event
  });

  const [editView, setEditView] = useState(false);
  // const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [timeModalOpen, setTimeModalOpen] = useState(false);
  const [isReminderOpen, setIsReminderOpen] = useState(false);
  const [radioMeta, setRadioMeta] = useState([]);
  const [displayName, setDisplayName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [selectedDisplayId, setSelectedDisplayId] = useState(null);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [inputText, setInputText] = useState("");
  const [inputTextDesc, setInputTextDesc] = useState(null);
  const [locationText, setLocationText] = useState(null);
  const [selectedDisplayName, setSelectedDisplayName] = useState(null);
  const [selectedChilds, setSelectedChilds] = useState(null);
  const [selectedCoupleId, setSelectedCoupleId] = useState(null);
  const [selectedChildIds, setSelectedChildIds] = useState(null);
  const [error, setError] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [repeatOption, setRepeatOption] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteType, setDeleteType] = useState("current");
  const [taskData, setTaskData] = useState({
    title: "",
    description: "",
    location: "",
  });
  const [selectedRadioId, setSelectedRadioId] = useState(null);

  const [checklist, setChecklist] = useState([
    { title: "", description: null, is_checked: 1, id: null },
  ]);
  const [value, setValue] = useState(1);
  const [selectedTime, setSelectedTime] = useState({ start: "", end: "" });
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [switchStates, setSwitchStates] = useState(false);
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [showRemModal, setShowRemModal] = useState(false);
  const [selectReminder, setSelectReminder] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  // console.log("eventData?.start_date",eventData?.start_date)
  const [descSelectedColor, setDescSelectedColor] = useState("No Color");
  const [notificationText, setNotificationText] = useState(
    "No notification data"
  );
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const formattedDate = moment(eventData.start_date).format("D, MMMM YYYY");
  // console.log("formattedDate",formattedDate)
  // console.log(couples, "couples");
  const [dummyCollaborators, setDummyCollaborators] = useState([
    {
      id: "1",
      name: "Thomas Shelby",
      email: "thomas@gmail.com",
      permission: "Can View",
      avatar: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: "2",
      name: "Emily Clarke",
      email: "emily@gmail.com",
      permission: "Can Edit",
      avatar: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: "3",
      name: "John Doe",
      email: "john@gmail.com",
      permission: "Can View",
      avatar: "https://i.pravatar.cc/40?img=3",
    },
  ]);
  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [showColorModal, setShowColorModal] = useState(false);

  // State for switch toggle
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [colorConfig, setColorConfig] = useState(null);
  const [selectedItemForDelete, setSelectedItemForDelete] = useState(null); // confirm deleteType
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false); // delete modal visible state
  const [switchStatesNotification, setSwitchStatesNotification] =
    useState(false);
  const [getAssignee, setGetAssignee] = useState([]);
  const [getCollaboraters, setGetCollabraters] = useState([]);
  const [assignBy, setAssignBy] = useState(null);
  const [individualTask, setIndividualTask] = useState(null);
  const [updatedUsers, setUpdatedUsers] = useState([]);

  const fetchTaskDetailsById = useCallback(async () => {
    try {
      if (!eventData?.task_id && !eventData?.event_id) {
        console.warn("Missing task ID or event ID");
        return;
      }

      const token = localStorage.getItem("authToken");
      const taskId = eventData?.task_id || eventData?.event_id;
      const type = eventData?.type; // "task" or "event"
      const occurrenceDate = eventData.occurrenceDate || eventData.start_date;

      const response = await fetch(
        `${URL}/v1/co-parenting/task-event-details/${taskId}?type=${type}&occurrence_date=${eventData.occurrenceDate}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      // console.log("Co-parent API Response:", data.data);
      setIndividualTask(data?.data);

      if (data.code === 200) {
        setGetAssignee(data.data.assignees || []);
        setAssignBy(data.data.assigned_by || {});
        setLocationText(data.data.location || undefined);
        setGetCollabraters(data.data.collaborators || []);
        setSelectedCoupleId(Number(data?.data?.combination_id) || null);
        if (data.data.is_notification_enabled !== undefined) {
          const isEnabled =
            data.data.is_notification_enabled === 1 ||
            data.data.is_notification_enabled === "1";
          setSwitchStatesNotification(isEnabled);
          setNotificationText(
            isEnabled ? "Notification Enabled" : "Notification Disabled"
          );
        }
        // Set children
        const childIds =
          data.data.children?.map((c) => String(c.child_id)) || [];
        // console.log(childIds, "childIds");

        setSelectedChildIds(childIds);

        // Set selectedChilds to the children of the selected couple
        const selectedCouple = couples.find(
          (couple) => couple.id == data?.data?.combination_id
        );
        // console.log(selectedCouple, "selectedCouple");

        setSelectedChilds(selectedCouple ? selectedCouple.children : []);
        // console.log(selectedChilds, "selectedChilds");
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  }, [eventData?.task_id, eventData?.event_id, eventData?.type]);

  useEffect(() => {
    if (isModalOpen) {
      fetchTaskDetailsById();
    }
  }, [eventData, isModalOpen]);

  useEffect(() => {
    if (getAssignee && getAssignee.length > 0) {
      const initialSelected = getAssignee.map((a) => a.member);
      setAssignedUsers(initialSelected); // ✅ Pre-select assignees
    }

    if (getCollaboraters && getCollaboraters.length > 0) {
      const initialSelected = getCollaboraters.map((collab) => ({
        ...collab.member,
        permission: collab.permission, // Include the permission data
      }));
      setSelectedCollaborators(initialSelected); // ✅ Pre-select collaborators
    }
  }, [getAssignee, getCollaboraters]);

  // const [metaData, setMetaData] = useState([]);
  // Repeat settings configuration
  const [repeatConfig, setRepeatConfig] = useState(null);
  // Toggle repeat switch
  const handleSwitchChangeRepeat = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesRepeat(newState);

    if (newState) {
      // Show modal when turning on
      setShowRepeatModal(true);
    } else {
      // Clear config when turning off
      setRepeatConfig(null);
    }
  };
  const handleSwitchChangeColor = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesColor(newState);

    if (newState) {
      // Show modal when turning on
      setSwitchStatesColor(true);
    } else {
      // Clear config when turning off
      setColorConfig(null);
    }
  };

  const handleSwitchChangeNotification = () => {
    const newState = !switchStatesNotification;
    setSwitchStatesNotification(newState);
  };

  const getRepeatDescription = () => {
    if (!switchStatesRepeat || !repeatConfig) return "No repeat";

    const { repeatType, endType, occurrences, customEndDate } = repeatConfig;

    if (!repeatType) return "No repeat";

    // Map repeatType string to a label
    const repeatLabels = {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    };

    const repeatLabel = repeatLabels[repeatType] || "Custom";

    const endText =
      endType === "custom"
        ? `until ${moment(customEndDate).format("D MMMM YYYY")}`
        : `after ${occurrences} ${occurrences === 1 ? "year" : "years"}`;

    return `${repeatLabel} (Ends ${endText})`;
  };

  useEffect(() => {
    if (eventData?.color_id && metaData?.colors) {
      const colorObj = metaData.colors.find(
        (c) => String(c.id) == String(eventData.color_id)
      );
      setColorConfig(colorObj || null);
      setSwitchStatesColor(colorObj?.label_name ? true : false);
      setDescSelectedColor(colorObj?.label_name || "No Color");
    }
    const startDate = moment(eventData.start);

    const repeatType = eventData.repeat_option || "daily";
    const endDate = eventData.repetition_end_date
      ? moment(eventData.repetition_end_date)
      : null;
    const endType = endDate ? "custom" : "after";

    let occurrences = 2; // default fallback
    if (endDate && startDate.isBefore(endDate)) {
      switch (repeatType) {
        case "daily":
          occurrences = endDate.diff(startDate, "days") + 1;
          break;
        case "weekly":
          occurrences = endDate.diff(startDate, "weeks") + 1;
          break;
        case "monthly":
          occurrences = endDate.diff(startDate, "months") + 1;
          break;
        default:
          break;
      }
    }

    const excludeWeekends = [];
    if (eventData.exclude_saturdays === "1") {
      excludeWeekends.push({ id: 2, label: "saturday" });
    }
    if (eventData.exclude_sundays === "1") {
      excludeWeekends.push({ id: 3, label: "sunday" });
    }
    if (eventData.repeat_option || eventData.repetition_end_date) {
      const values = {
        repeatType: { value: repeatType },
        endType,
        occurrences,
        customEndDate: endDate ? endDate.format("YYYY-MM-DD") : null,
        excludeWeekends,
        adjustWeekends: eventData.adjust_weekends || false,
      };
      setRepeatConfig(values);
      setSwitchStatesRepeat(true);
    } else {
      setRepeatConfig(null);
      setSwitchStatesRepeat(false);
    }

    if (individualTask?.reminder_timestamp) {
      let reminderText = individualTask?.reminder_timestamp
        ? getReminderPresetLabel(
            individualTask?.start_time,
            individualTask?.reminder_timestamp
          )
        : "No reminder";
      setDescSelectedReminder(reminderText);
    }
    // if (eventData?.is_notification_enabled === 0) {
    //   setSwitchStatesNotification(true);
    //   setNotificationText("Notification Disabled" || "Notification Enabled");
    // }
    if (individualTask?.assignees || individualTask?.participants) {
      const assigneesOrParticipants =
        individualTask?.assignees?.length > 0
          ? individualTask.assignees
          : individualTask?.participants || [];

      const displayNameId = Number(individualTask?.display_name_id);

      const assignedNames = assigneesOrParticipants.map((assignee) => {
        // Find the parent from couples array by matching parent_id with user_id
        const foundParent = couples
          .flatMap((couple) => [couple.parent1, couple.parent2])
          .find((parent) => parent.user_id === assignee.parent_id);

        const nickname = foundParent?.nickname || assignee?.co_parent_nickname;
        const name = foundParent?.name || assignee?.name;
        const email =
          foundParent?.email ||
          assignee?.email ||
          assignee?.coparent_email ||
          "Unknown";

        // Apply display_name_id rules
        if (displayNameId === 21) {
          return name || nickname || email;
        } else if (displayNameId === 20) {
          return nickname || name || email;
        } else {
          // fallback if display_name_id is missing or unexpected
          return name || nickname || email;
        }
      });

      // Filter out "Unknown" or empty values
      const filteredNames = assignedNames.filter(
        (name) => name && name !== "Unknown"
      );

      setAssignedUsers(assigneesOrParticipants);
      console.log(filteredNames);

      setAssignName(filteredNames.join(", "));
    }
    // Set couple
  }, [eventData, metaData, individualTask]);

  // console.log(assignName, "assignName");

  // Handle saving from RepeatModal
  const handleRepeatSave = (data) => {
    // console.log("repeat data", data);
    setRepeatConfig(data);
    setSwitchStatesRepeat(true);
    setShowRepeatModal(false);
    getRepeatDescription();
  };
  const handleColorSave = (data) => {
    // console.log("data", data);
    // setRepeatConfig(data);
    setColorConfig(data);
    if (!data.id) {
      setSwitchStatesColor(false);
    } else {
      setSwitchStatesColor(true);
    }
    setShowColorModal(false);
    setDescSelectedColor(data.label_name);
  };
  // Cancel modal
  const handleRepeatCancel = () => {
    // If no config and switch is off, don't keep modal open
    if (!repeatConfig) {
      setSwitchStatesRepeat(false);
    }
    setShowRepeatModal(false);
  };
  const handleColorCancel = () => {
    // If no config and switch is off, don't keep modal open
    // if (!repeatConfig) {
    //   setSwitchStatesColor(false);
    // }
    setShowColorModal(false);
  };

  const handleSwitchChangeCollaboration = (checked) => {
    setSwitchStatesCollaboration(checked);
  };

  const handleSaveCollaboration = (selected) => {
    setSelectedCollaborators(selected);
    setSwitchStatesCollaboration(selected.length > 0);
    setShowCollaborationModal(false);

    // Add any new collaborators not already in dummyCollaborators
    const newCollaborators = selected.filter(
      (sel) => !dummyCollaborators.some((c) => c.id === sel.id)
    );
    if (newCollaborators.length > 0) {
      setDummyCollaborators((prev) => [...prev, ...newCollaborators]);
    }
    // console.log("dummyCollaborators", selectedCollaborators);
  };

  // if (individualTask?.checklist) {
  //   setChecklist(individualTask?.checklist)
  // }
  const setEditInitialValues = () => {
    setInputText(eventData?.title || "");
    setInputTextDesc(eventData?.description || "");
    setLocationText(eventData?.location || "");
    // setSelectedDate(eventData?.start_date || null);

    // Set time (assuming eventData.start_time and end_time are "YYYY-MM-DD HH:mm:ss")

    setSelectedTime({
      start: individualTask?.start_time
        ? moment.utc(individualTask?.start_time).format("HH:mm")
        : "",
      end: individualTask?.end_time
        ? moment.utc(individualTask?.end_time).format("HH:mm")
        : "",
    });
    setSelectedReminder(eventData?.reminder);
    if (selectedReminder) {
      setSwitchStatesRem(true);
    }
    // setSelectedCoupleId(Number(eventData?.combination_id) || null);

    // Set children
    // const childIds = eventData?.children?.map(c => String(c.child_id)) || [];
    // setSelectedChildIds(childIds);

    // Set selectedChilds to the children of the selected couple
    // const selectedCouple = couples.find(couple => couple.id == eventData?.primary_user_id);
    // setSelectedChilds(selectedCouple ? selectedCouple.children : []);

    // Set Status (progress)
    //   console.log("eventData?.progress_status_id", eventData?.progress_status_id)
    setSelectedRadioId(
      eventData?.progress_status_id
        ? Number(eventData.progress_status_id)
        : null
    );

    // When setting initial values (in setEditInitialValues or useEffect)
    setSelectedDisplayId(Number(eventData?.display_name_id) || null);
    setSelectedPriorityIds(Number(eventData?.priority_id) || null);

    // Set checklist if available
    if (individualTask?.checklist || individualTask?.check_list) {
      setChecklist(
        (individualTask?.checklist || eventData.check_list || []).map(
          (item) => ({
            title: item.title,
            is_checked: item.is_checked,
            id: item.id,
          })
        )
      );
    }
    // if (eventData?.assignees) {
    //   let name = eventData.assignees.map(a => String(a.coparent_nickname))
    //   setAssignedUsers(eventData.assignees.map(a => String(a.coparent_nickname)));
    // }

    // Set color config if available
    if (eventData?.color_id && metaData?.colors) {
      const colorObj = metaData.colors.find(
        (c) => String(c.id) === String(eventData.color_id)
      );
      setColorConfig(colorObj || null);
      setDescSelectedColor(colorObj?.label_name || "No Color");
    } else {
      setColorConfig(null);
      setDescSelectedColor("No Color");
    }

    // Set reminder if available

    // Set assigned users and collaborators if available
    if (eventData?.collaborators) {
      setSelectedCollaborators(
        eventData.collaborators.map((a) => ({
          id: a.member_id,
          name: a.member?.invitee_nickname,
          email: a.member?.invitee_email,
        }))
      );
    }
  };
  const descSelectedCollaboration =
    selectedCollaborators.length > 0
      ? selectedCollaborators.map((c) => c.name).join(", ")
      : "No collaborators selected";

  const userList = [
    {
      id: "1",
      name: "John Doe",
      email: "john.doe@example.com",
      avatar: "https://randomuser.me/api/portraits/men/1.jpg",
    },
    {
      id: "2",
      name: "Jane Smith",
      email: "jane.smith@example.com",
      avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    },
    {
      id: "3",
      name: "Alice Johnson",
      email: "alice.johnson@example.com",
      avatar: "https://randomuser.me/api/portraits/women/3.jpg",
    },
    {
      id: "4",
      name: "Bob Brown",
      email: "bob.brown@example.com",
      avatar: "https://randomuser.me/api/portraits/men/4.jpg",
    },
  ];

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setShowModal(false); // Close modal after selecting a date
    setSwitchStates(!!date); // Correctly update state
    // console.log("Selected Date:", date);
  };

  const handleSwitchChange = () => {
    setShowModal(true);
  };
  const handleSwitchChangeTime = () => {
    setShowTimeModal(true);
  };
  const handleSwitchChangeaAssign = () => {};

  const handleSwitchChangeRem = (checked) => {
    if (!checked) {
      // If the switch was ON and now turned OFF, show the modal
      setShowRemModal(true);
    } else {
      // If the switch was OFF and now turned ON
      setSelectedReminder(null);
      setSwitchStatesRem(!checked); // Ensure the switch turns ON
      setShowRemModal(false);
    }

    // console.log("Switch State:", checked);
  };

  const handleSelectDisplay = (id) => {
    setSelectedDisplayId(id); // Store only one selected ID
  };

  // Handle selecting a Priority
  const handleSelectPriority = (id) => {
    setSelectedPriorityIds(id);
  };

  const getCalenderMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        // console.log("getCalenderMetaData", data.data);
        setProgressStatus(data.data.progress_status);
        // setMetaData(data.data)
        setRadioMeta(data.data.progress_status);
        setDisplayName(data.data.display_name);
        setPriority(data.data.priority);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };
  const statusLabel =
    progressStatus.find(
      (status) => status.id === Number(eventData?.progress_status_id)
    )?.label_name || "Unknown";
  const priorityLabel =
    priority.find((status) => status.id === Number(eventData?.priority_id))
      ?.label_name || "Unknown";
  const displayLabelId =
    displayName.find(
      (status) => status.id === Number(eventData?.display_name_id)
    )?.label_name || "Unknown";

  useEffect(() => {
    // getCalenderMetaData()
    setProgressStatus(calenderMetaData.progress_status);
    setRadioMeta(calenderMetaData.progress_status);
    setDisplayName(calenderMetaData.display_name);
    setPriority(calenderMetaData.priority);
    setRepeatOption(calenderMetaData.repeat_option);
  }, []);

  const onChange = (key) => {
    // console.log(key);
  };

  const getReminderPresetLabel = (startTime, reminderTime) => {
    if (!startTime || !reminderTime) return "No reminder";
    // const diffMinutes = moment(startTime).diff(moment(reminderTime), "minutes");
    const start = moment.utc(startTime);
    const reminder = moment.utc(reminderTime);

    const diffMinutes = start.diff(reminder, "minutes");
    const diffHours = start.diff(reminder, "hours") || 0;
    const diffDays = start.diff(reminder, "days") || 0;
    if (diffMinutes === 5) return "5 minute before";
    if (diffMinutes === 30) return "30 minute before";
    if (diffMinutes === 60) return "1 hour before";
    if (diffMinutes === 1440) return "1 day before";
    if (diffDays === 0 && diffHours === 0 && diffMinutes > 0) {
      return `${diffMinutes} minutes before`;
    } else if (diffDays === 0 && diffHours > 0) {
      return `${diffHours} hours, ${diffMinutes % 60} minutes before`;
    } else if (diffDays > 0) {
      return `${diffDays} days, ${diffHours % 24} hours, ${
        diffMinutes % 60
      } minutes before`;
    }
    return "No reminder";
  };

  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    const validReminderMap = {
      5: "5 minute before",
      30: "30 minute before",
      60: "1 hour before",
      1440: "1 day before",
    };

    const formattedDate = moment(selectedDate, [
      "D MMMM YYYY",
      "DD, MMMM YYYY",
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "DD MMM YYYY",
    ]);

    if (!formattedDate.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid date" };
    }

    const formattedStartTime = moment(selectedTime?.start, [
      "HH:mm",
      "HH:mm:ss",
    ]);
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid time" };
    }

    const taskStart = moment.utc(
      `${formattedDate.format("YYYY-MM-DD")}T${formattedStartTime.format(
        "HH:mm"
      )}:00Z`
    );

    const taskStartTime = taskStart.format("YYYY-MM-DDTHH:mm:ss[Z]");
    if (!selectedReminder) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const reminderTime = moment.utc(selectedReminder);

    if (!reminderTime.isValid() || !reminderTime.isBefore(taskStart)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = taskStart.diff(reminderTime, "minutes");

    if (validReminderMap[diffMinutes]) {
      return { taskStartTime, reminderText: validReminderMap[diffMinutes] };
    }

    // Compute human-readable fallback for Customize...
    const totalMinutes = diffMinutes;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

    const customizeLabel =
      parts.length > 0
        ? `Customize...(${parts.join(", ")} before)`
        : "Customize...";

    return { taskStartTime, reminderText: customizeLabel };
  };

  const handleSelectTime = (timeData) => {
    setSelectedTime(timeData);

    setSwitchTimeStates(!!timeData);
    // Example output: { startTime: "08:00", endTime: "09:00" }
  };

  const handleSelectReminder = (reminder) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);

    // console.log("SelectedReminder>>", reminder, "Task Start Time>>", taskStartTime);
  };
  const selectTextReminder = (item) => {
    // console.log("nananan",item)
    setDescSelectedReminder(item);
  };
  const getTabName = (key) => (key == "1" ? "task" : "event");

  const tabName = eventData?.type;
  // Convert tab number to "task" or "event"

  const handleCoupleChange = (value) => {
    // console.log("Selected couple ID:", value);
    setSelectedCoupleId(value);
    setSelectedChildIds(null);
    // Fetch children based on selected couple ID
    const selectedCouple = couples.find((couple) => couple.id === value);
    if (selectedCouple) {
      const children = selectedCouple.children.map((child) => ({
        id: child.id,
        name: child.name,
      }));
      // console.log("Selected couple's children:", selectedCouple.children);
      setSelectedChilds(selectedCouple.children);
    }
  };
  useEffect(() => {
    if (individualTask?.children) {
      setSelectedChildIds(
        individualTask?.children.map((c) => String(c.child_id))
      );
    }
  }, [individualTask]);

  const handleChildSelect = (value) => {
    // console.log("Selected child ID:", value);
    setSelectedChildIds(value);
  };

  const eventStartDate = individualTask?.start_date;
  const eventStartTime = individualTask?.start_time
    ? moment.utc(individualTask.start_time).format("HH:mm")
    : null;
  const currentTime = moment().format("HH:mm");

  // Get today's date in "YYYY-MM-DD" format
  const todaysDate = moment().format("YYYY-MM-DD");

  // Check if event is in the past (considering both date and time)
  const isPastEvent =
    eventStartDate &&
    (moment(eventStartDate).isBefore(todaysDate, "day") ||
      (moment(eventStartDate).isSame(todaysDate, "day") &&
        eventStartTime &&
        moment(currentTime, "HH:mm").isAfter(moment(eventStartTime, "HH:mm"))));

  // console.log(
  //   "eventData",
  //   eventStartDate,
  //   eventStartTime,
  //   "todays: ",
  //   currentTime,
  //   todaysDate,
  //   "isPast: ",
  //   isPastEvent
  // );
  const handleEditOpen = () => {
    if (isPastEvent) {
      Modal.info({
        title: "Past Event",
        content: "This event is in the past and cannot be edited.",
        okText: "OK",
      });
      return;
    }
    setEditInitialValues();
    setEditView(true);
  };
  const manageDelete = () => {
    if (isPastEvent) {
      Modal.info({
        title: "Past Event",
        content: "This event is in the past and cannot be deleted.",
        okText: "OK",
      });
      return;
    }
    // console.log("manageDelete called with eventData:", eventData);
    if (eventData.repeat_option) {
      setShowDeleteModal(true);
    } else {
      setIsDeleteModalVisible(true);
    }
  };
  const handleDelete = async () => {
    console.log("taskId", taskId, eventData, tabName);
    // return
    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/delete-${tabName}/${taskId}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );

      const data = await response.json();
      if (data.code === 200) {
        message.success(`${tabName} Deleted Successfully`);
        closeModal();
        if (onTaskUpdate) {
          onTaskUpdate();
        }
        // Clear form fields and state after successful submission

        setError(false);
      } else {
        message.error(`Failed to create ${tabName}`);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleDeleteWithType = async (type) => {
    try {
      const payload = {
        delete_type: type || deleteType,
        occurrence_date: eventData?.occurrenceDate, // or use eventData?.occurrence_date if available
        id: eventData?.task_id
      };
      // console.log(payload, "delete payload");

      const id =
        individualTask?.task_master_id || individualTask?.event_master_id;
      const response = await fetch(
        `${URL}/v1/co-parenting/delete-${tabName}/${id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (data.code === 200) {
        message.success(`${tabName} Deleted Successfully`);
        closeModal();
        if (onTaskUpdate) {
          onTaskUpdate();
        }
        setError(false);
      } else {
        message.error(`Failed to delete ${tabName}`);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleviewOpen = () => {
    setEditView(false);
    setSelectedDate(formattedDate);
    setInputText(eventData?.title || "");
    setInputTextDesc(eventData?.description || "");
    setLocationText(eventData?.location || "");
    // Set time (assuming eventData.start_time and end_time are "YYYY-MM-DD HH:mm:ss")
  };

  // const handleSubmit = async () => {

  //   const formattedStartTime = `${selectedDate}T${selectedTime.startTime}:00Z`;
  //   const formattedEndTime = `${selectedDate}T${selectedTime.endTime}:00Z`;

  //   const payload = {

  //     title: inputText,
  //     location: locationText,
  //     description: inputTextDesc,
  //     display_name_id: selectedDisplayId,
  //     priority_id: selectedPriorityIds,
  //     progress_status_id: selectedRadioId,
  //     start_date: selectedDate,
  //     start_time: formattedStartTime,
  //     end_time: formattedEndTime,
  //     reminder_timestamp: selectedReminder,
  //     check_list: checkedItems

  //   };

  //   try {
  //     const response = await fetch(`${URL}/v1/${tabName}/create`, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //         "Cache-Control": "no-cache",
  //       },
  //       body: JSON.stringify(payload),
  //     });
  //     const data = await response.json();
  //     if (data.code == 200) {
  //       message.success(`${tabName} Created  Successfully`);
  //       closeModal()

  //     } else if (data.code !== 200) {
  //       message.error(`failed to Create ${tabName}`); // ✅ Show error if keyword selection fails

  //     }
  //   } catch (error) {
  //   }
  // };
  const handleConfirmUpdate = async (payload) => {
    try {
      const { type, id, occurrenceDate } = selectedItemForDelete;
      await handleSubmitNew(type, id, occurrenceDate, payload.update_type);
    } catch (err) {
      console.error("Failed to update task", err);
    } finally {
      setIsUpdateModalVisible(false);
    }
  };
  const handleUpdateEvent = async (type, taskOReventId, occurrenceDate) => {
    // console.log("handleUpdateEvent called with:", { eventData,type,taskOReventId });
    // return
    setSelectedItemForDelete({
      type,
      id: taskOReventId,
      occurrenceDate,
    });
    if (eventData.repeat_option) {
      setIsUpdateModalVisible(true);
    } else {
      // const { type, id, occurrenceDate } = selectedItemForDelete ? selectedItemForDelete : null;
      await handleSubmitNew(type, taskOReventId, occurrenceDate, "all");
    }
  };

  const handleSubmitNew = async (
    type,
    taskId,
    occurrenceDate,
    update_type = "current"
  ) => {
    if (!inputText.trim() || !inputText) {
      setError(true);
      message.error("Task name is required!");
      return;
    }

    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );
    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    // Ensure start time, end time, and reminder timestamp are in ISO 8601 UTC format
    let formattedDate = moment(formattedStartDate);
    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }
    let formattedStartTime = moment(
      selectedTime.start,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    const taskStartTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
          "HH:mm"
        )}`,
        "YYYY-MM-DD HH:mm"
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    let formattedEndTime = moment(
      selectedTime.end,
      ["HH:mm", "HH:mm:ss"],
      true
    );

    const taskEndTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime.format(
          "HH:mm"
        )}`,
        "YYYY-MM-DD HH:mm"
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    let formattedReminder;

    if (descSelectedReminder === "Customize...") {
      // Use the manual absolute reminder selected by user
      formattedReminder = moment(selectedReminder).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
    } else {
      // Recalculate based on new taskStartTime + description
      const eventDateTime = moment(taskStartTime, "YYYY-MM-DDTHH:mm:ss[Z]");
      switch (descSelectedReminder) {
        case "5 minute before":
          formattedReminder = eventDateTime
            .clone()
            .subtract(5, "minute")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          break;
        case "30 minute before":
          formattedReminder = eventDateTime
            .clone()
            .subtract(30, "minute")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          break;
        case "1 hour before":
          formattedReminder = eventDateTime
            .clone()
            .subtract(1, "hour")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          break;
        case "1 day before":
          formattedReminder = eventDateTime
            .clone()
            .subtract(1, "day")
            .format("YYYY-MM-DDTHH:mm:ss[Z]");
          break;
        default:
          formattedReminder = null;
      }
    }
    // const checkedItems = checklist.filter(item => item.checked).map(item => item.text);
    const checkListItems = checklist.map((item) => ({
      title: item.title,
      id: item.new_status ? null : item.id,
      // description: '', // You can customize the description here
      is_checked: item.is_checked,
    }));
    const selectedChildIdsNumber = Array.isArray(selectedChildIds)
      ? selectedChildIds.map(Number)
      : [];
    const calculateEndDate = (repeatConfig) => {
      if (!repeatConfig || !formattedStartDate) return null;
      const { endType, occurrences, customEndDate } = repeatConfig;
      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }
      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };
    // console.log("update_type", update_type, occurrenceDate);
    // console.log("eventData::", eventData);
    // console.log("assignedUsers", eventData?.assignees);
    // console.log("updatedUsers", updatedUsers);

    const formatedAssign =
      updatedUsers?.length > 0
        ? updatedUsers
            .filter((user) => user?.parent_id) // only those with parent_id
            .map((user) => user.parent_id) || []
        : (individualTask?.assignees ?? individualTask?.participants)
            ?.filter((user) => user?.parent_id) // only those with parent_id
            .map((user) => user.parent_id) || [];

    const formatedEmails =
      updatedUsers?.length > 0
        ? updatedUsers
            .filter((user) => !user?.parent_id && user?.coparent_email) // no parent_id → take email
            .map((user) => user.coparent_email) || []
        : (individualTask?.assignees ?? individualTask?.participants)
            ?.filter((user) => !user?.parent_id && user?.coparent_email) // no parent_id → take email
            .map((user) => user.coparent_email) || [];
    const taskPayload = {
      coparent_combination_id: selectedCoupleId,
      child_ids: selectedChildIdsNumber,
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadioId,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      assignee_ids: formatedAssign, // Use parent_id for assignee
      assignee_emails: formatedEmails, // Use coparent_email for assignees
      color_id: colorConfig?.id,
      occurrence_date: moment(eventData.start_date).format("YYYY-MM-DD"),
      update_type: repeatConfig?.repeatType?.value ? update_type : "current",
      reminder_timestamp: switchStatesRem
        ? formattedReminder
        : eventData?.reminder
        ? moment(eventData.reminder, "YYYY-MM-DD HH:mm").format(
            "YYYY-MM-DDTHH:mm:ss[Z]"
          )
        : null,
      repeat_option:
        update_type == "current"
          ? null
          : repeatConfig?.repeatType?.value ?? eventData?.repeat_option,
      repetition_end_date:
        update_type == "current"
          ? null
          : repeatConfig?.endType === "custom"
          ? repeatConfig?.customEndDate
            ? moment(repeatConfig.customEndDate).format("YYYY-MM-DD")
            : eventData?.repetition_end_date // fallback if not selected
          : repeatConfig
          ? calculateEndDate(repeatConfig)
          : eventData?.repetition_end_date,
      exclude_saturdays: hasSaturday ? 1 : 0,
      exclude_sundays: hasSunday ? 1 : 0,
      is_notification_enabled: switchStatesNotification ? 1 : 0,
      adjust_weekends: adjustWeekendsValue,
    };

    // console.log("taskPayload", taskPayload);
    // Payload for Event (with additional fields like event description)
    const eventPayload = {
      coparent_combination_id: selectedCoupleId,
      child_ids: selectedChildIdsNumber,
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadioId,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      check_list: checkListItems, // If event-related, include checklist
      color_id: colorConfig?.id,
      participant_ids: formatedAssign, // Use parent_id for participant
      participant_emails: formatedEmails, // Use coparent_email for participant
      occurrence_date: moment(eventData.start_date).format("YYYY-MM-DD"),
      update_type: repeatConfig?.repeatType?.value ? update_type : "current",
      reminder_timestamp: switchStatesRem
        ? formattedReminder
        : eventData?.reminder
        ? moment(eventData.reminder, "YYYY-MM-DD HH:mm").format(
            "YYYY-MM-DDTHH:mm:ss[Z]"
          )
        : null,
      repeat_option:
        update_type == "current"
          ? null
          : repeatConfig?.repeatType?.value || eventData?.repeat_option,
      repetition_end_date:
        update_type == "current"
          ? null
          : repeatConfig?.endType === "custom"
          ? moment(repeatConfig.customEndDate).format("YYYY-MM-DD")
          : calculateEndDate(repeatConfig),
      exclude_saturdays: hasSaturday ? 1 : 0,
      exclude_sundays: hasSunday ? 1 : 0,
      is_notification_enabled: switchStatesNotification ? 1 : 0,
      adjust_weekends: adjustWeekendsValue,
    };

    const payload = tabName === "task" ? taskPayload : eventPayload;

    // console.log("Final Payload:", payload, eventData[`${tabName}_id`]);
    // return https://api.quelld.webdezign.uk/api/v1/task/update/TASK-000000000000001  https://api.quelld.webdezign.uk/api/v1/co-parenting/task/update/TASK-000000000000079
    // console.log(tabName);

    const id =
      individualTask?.task_master_id || individualTask?.event_master_id;

    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/update-${tabName}/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (data.code === 200) {
        message.success(`${tabName} Updated Successfully`);
        resetFormFields();
        closeModal();
        // Clear form fields and state after successful submission
        setError(false);
        // window.location.reload()
        if (onTaskUpdate) {
          onTaskUpdate();
        }
      } else {
        message.error(`Failed to update ${tabName}`);
      }
    } catch (error) {
      message.error(`Failed to create ${tabName}`);
      console.error("Error:", error);
      setTimeout(() => window.location.reload(), 3000);
    }
  };
  useEffect(() => {
    if (eventData?.id) {
      setTaskId(eventData.id);
    }
    if (eventData.progress_status_id) {
      const selectedStatus = progressStatus.find(
        (status) => status.id == eventData.progress_status_id
      );
      if (selectedStatus) {
        setSelectedRadioId(selectedStatus.id);
      }
    }
    // console.log("eventData", eventData);
    // const getAssigneeData = eventData?.assignees
    // ?.map(a => a.member?.invitee_nickname)
    // .filter(name => !!name) // filter out null/undefined
    // .join(", ");
    // setAssignName(getAssigneeData)

    const collaboratorsNameNew = eventData?.collaborators
      ?.map((a) => a.member?.invitee_nickname)
      .filter((name) => !!name) // filter out null/undefined
      .join(", ");

    setCollaboratorsName(collaboratorsNameNew);
  }, [eventData]);

  useEffect(() => {
    if (eventData?.start) {
      setSelectedDate(moment.utc(eventData?.start).format("D, MMMM YYYY"));
      setSwitchStates(true); // ✅ Enable switch if start date exists
    } else {
      setSelectedDate("No Date");
      setSwitchStates(false); // Reset switch if no date found
    }
  }, [eventData?.start, eventData?.end, eventData?.reminder]);

  const resetFormFields = () => {
    setInputText(null);
    setInputTextDesc(null);
    setLocationText(null);
    setSelectedDate(null);
    setSelectedTime({ start: "", end: "" });
    setSelectedReminder("No reminder");
    setDescSelectedReminder("No reminder");
    setDescSelectedColor("No Color");
    setSelectedDisplayId(null);
    setSelectedPriorityIds(null);
    setSelectedRadioId(null);
    setSwitchStates(false);
    setSwitchTimeStates(false);
    setSwitchStatesRem(false);
    setChecklist([]); // Reset checklist
  };

  const handleChange = (e) => {
    setInputText(e.target.value);
    setError(false); // Clear error when user types

    // Update state on input change
  };

  const handleChangeDesc = (e) => {
    setInputTextDesc(e.target.value); // Update state on input change
  };
  const handleChangeLocation = (e) => {
    setLocationText(e.target.value); // Update state on input change
  };

  const handleRadioChange = (e) => {
    const slectedStatusID = e.target.value;
    setSelectedRadioId(slectedStatusID);
  };
  // console.log(selectedTime, "selectedTime");

  const options = [
    { label: "Pending", value: "pending" },
    { label: "Success", value: "success" },
  ];
  const eventContent = (
    <div>
      <div className="addTaskLabel">
        <FloatLabel
          label="What is the name of your Event"
          name="taskTitle"
          value={inputText}
          required
        >
          <Input value={inputText} onChange={handleChange} placeholder="" />
        </FloatLabel>
        {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
      </div>

      <FloatLabel
        label="Description"
        name="taskDescription"
        value={inputTextDesc}
      >
        <Input.TextArea
          placeholder=""
          value={inputTextDesc}
          onChange={handleChangeDesc}
          autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </FloatLabel>

      <FloatLabel label="Location" name="taskLocation" value={locationText}>
        <Input
          placeholder=""
          value={locationText}
          onChange={handleChangeLocation}
        />
      </FloatLabel>
      <FloatLabel label="Select a couple" value={selectedCoupleId} required>
        <Select
          placeholder=""
          width="100%"
          style={{ display: "flex", marginBottom: "20px" }}
          onChange={handleCoupleChange}
          value={selectedCoupleId}
          disabled={!editView}
        >
          {couples.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.parent1.name && item.parent1.name.trim() !== ""
                ? item.parent1.name
                : item.parent1.nickname && item.parent1.nickname.trim() !== ""
                ? item.parent1.nickname
                : item.parent1.email}
              -
              {item.parent2.name && item.parent2.name.trim() !== ""
                ? item.parent2.name
                : item.parent2.nickname && item.parent2.nickname.trim() !== ""
                ? item.parent2.nickname
                : item.parent2.email}
            </Select.Option>
          ))}
        </Select>
      </FloatLabel>

      {selectedChilds && selectedChilds.length > 0 && (
        <FloatLabel label="Select childs" value={selectedChildIds} required>
          <Select
            className="child-multiselect-picker"
            maxTagCount={3}
            mode="multiple"
            // labelInValue
            value={selectedChildIds.map((id) => {
              const child = selectedChilds.find(
                (c) => String(c.id) === String(id)
              );
              return child
                ? { value: id, label: child.name }
                : { value: id, label: id };
            })}
            placeholder=""
            width="100%"
            style={{ display: "flex", marginBottom: "10px", marginTop: "20px" }}
            onChange={handleChildSelect}
            disabled={!editView}
          >
            {selectedChilds.map((item) => (
              <Select.Option
                key={item.id}
                value={Number(item.id)}
                disabled={selectedChildIds.includes(item.id)}
              >
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </FloatLabel>
      )}

      <div>
        <ChecklistComponent
          checklist={checklist}
          setChecklist={setChecklist}
          isUpdate={true}
        />
      </div>
      {/* Status */}
      <div style={{ marginTop: 10 }} className="radio-container">
        <h3
          style={{ fontWeight: "bold", fontSize: 16, marginBottom: 0 }}
          className="radio-label"
        >
          Status <span style={{ color: "red" }}>*</span>
        </h3>
        {selectedRadioId && (
          <Radio.Group
            // className="custom-radio-group"
            onChange={handleRadioChange}
            defaultValue={26} // This should be a number
            disabled={!editView}
          >
            {progressStatus.map((status) => (
              <Radio key={status.id} value={Number(status.id)}>
                {status.label_name}
              </Radio>
            ))}
          </Radio.Group>
        )}
      </div>
      <div style={{ marginTop: 15 }}>
        <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
          Preferred Display Name <span style={{ color: "red" }}>*</span>
        </h3>
        {displayName.map((status) => (
          <Tag
            onClick={() => editView && handleSelectDisplay(status.id)}
            style={{
              backgroundColor:
                selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
              color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
              border:
                selectedDisplayId === status.id
                  ? "1px solid #9A4FE0"
                  : "1px solid #E1E6EF",
              borderRadius: "10px",
              cursor: editView ? "pointer" : "not-allowed",
              fontSize: "14px",
              padding: "8px 12px",
              lineHeight: "18px",
              opacity: editView ? 1 : 0.7,
            }}
            key={status.id}
            value={selectedDisplayId}
            disabled={!editView}
          >
            {status.label_name}
          </Tag>
        ))}
      </div>
      {/* Priority */}
      <div style={{ marginTop: 15, marginBottom: 20 }}>
        <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
          Priority <span style={{ color: "red" }}>*</span>
        </h3>
        {priority.length > 0 ? (
          priority.map((status) => (
            <Tag
              onClick={() => editView && handleSelectPriority(status.id)}
              style={{
                backgroundColor:
                  selectedPriorityIds === status.id ? "#FEF1FE" : "#ffffff",
                color: selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                border:
                  selectedPriorityIds === status.id
                    ? "1px solid #9A4FE0"
                    : "1px solid #E1E6EF",
                borderRadius: "10px",
                cursor: editView ? "pointer" : "not-allowed",
                fontSize: "14px",
                padding: "8px 12px",
                lineHeight: "18px",
                opacity: editView ? 1 : 0.7,
              }}
              key={status.id}
              disabled={!editView}
            >
              {status.label_name}
            </Tag>
          ))
        ) : (
          <p>Loading...</p> // Optional loading state
        )}
      </div>
    </div>
  );
  const taskContent = (
    <div>
      <div className="addTaskLabel">
        <FloatLabel
          label="What is the name of your task"
          name="taskTitle"
          value={inputText}
          required
        >
          <Input
            value={inputText}
            onChange={handleChange}
            style={{ marginBottom: "10px" }}
            disabled={!editView}
            placeholder=""
          />
        </FloatLabel>
        {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
      </div>

      <FloatLabel
        label="Description"
        name="taskDescription"
        value={inputTextDesc}
      >
        <Input.TextArea
          value={inputTextDesc}
          onChange={handleChangeDesc}
          autoSize={{ minRows: 1, maxRows: 6 }}
          style={{ marginBottom: "10px" }}
          readOnly={!editView}
          placeholder=""
        />
      </FloatLabel>

      <FloatLabel label="Location" name="taskLocation" value={locationText}>
        <Input
          value={locationText}
          onChange={handleChangeLocation}
          style={{ marginBottom: "10px" }}
          disabled={!editView}
          placeholder=""
        />
      </FloatLabel>
      <FloatLabel label="Select a couple" value={selectedCoupleId} required>
        <Select
          placeholder=""
          width="100%"
          style={{ display: "flex", marginBottom: "20px" }}
          onChange={handleCoupleChange}
          value={selectedCoupleId}
          disabled={!editView}
        >
          {couples.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.parent1.name && item.parent1.name.trim() !== ""
                ? item.parent1.name
                : item.parent1.nickname && item.parent1.nickname.trim() !== ""
                ? item.parent1.nickname
                : item.parent1.email}
              -
              {item.parent2.name && item.parent2.name.trim() !== ""
                ? item.parent2.name
                : item.parent2.nickname && item.parent2.nickname.trim() !== ""
                ? item.parent2.nickname
                : item.parent2.email}
            </Select.Option>
          ))}
        </Select>
      </FloatLabel>
      {selectedChilds && selectedChilds.length > 0 && (
        <FloatLabel label="Select childs" value={selectedChildIds} required>
          <Select
            mode="multiple"
            value={selectedChildIds}
            placeholder=""
            width="100%"
            style={{ display: "flex", marginBottom: "10px", marginTop: "20px" }}
            onChange={handleChildSelect}
            disabled={!editView}
          >
            {selectedChilds.map((item) => (
              <Select.Option key={item.id} value={String(item.id)}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </FloatLabel>
      )}

      {/* <div>
      <ChecklistComponent checklist={checklist} setChecklist={setChecklist} />
    </div> */}
      {/* Status */}
      <div style={{ marginTop: 15 }} className="radio-container">
        <h3 style={{ marginBottom: 0, fontSize: 16 }} className="radio-label">
          Status <span style={{ color: "red" }}>*</span>
        </h3>
        <Radio.Group
          className="custom-radio-group"
          onChange={handleRadioChange}
          value={selectedRadioId}
          disabled={!editView}
        >
          {radioMeta.length > 0 ? (
            radioMeta.map((status) => (
              <Radio key={status.id} value={status.id} className="custom-radio">
                {status.label_name}
              </Radio>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </Radio.Group>
      </div>
      <div style={{ marginTop: 15 }}>
        <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
          Preferred Display Name <span style={{ color: "red" }}>*</span>
        </h3>
        {displayName.map((status) => (
          <Tag
            onClick={() => editView && handleSelectDisplay(status.id)}
            value={selectedDisplayId}
            style={{
              backgroundColor:
                selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
              color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
              border:
                selectedDisplayId === status.id
                  ? "1px solid #9A4FE0"
                  : "1px solid #E1E6EF",
              borderRadius: "10px",
              cursor: editView ? "pointer" : "not-allowed",
              fontSize: "14px",
              padding: "8px 12px",
              lineHeight: "18px",
              opacity: editView ? 1 : 0.7,
            }}
            key={status.id}
            disabled={!editView}
          >
            {status.label_name}
          </Tag>
        ))}
      </div>
      {/* Priority */}
      <div style={{ marginTop: 15, marginBottom: 15 }}>
        <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
          Priority <span style={{ color: "red" }}>*</span>
        </h3>
        {priority.length > 0 ? (
          priority.map((status) => (
            <Tag
              onClick={() => editView && handleSelectPriority(status.id)}
              style={{
                backgroundColor:
                  selectedPriorityIds === status.id ? "#FEF1FE" : "#ffffff",
                color: selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                border:
                  selectedPriorityIds === status.id
                    ? "1px solid #9A4FE0"
                    : "1px solid #E1E6EF",
                borderRadius: "10px",
                cursor: editView ? "pointer" : "not-allowed",
                fontSize: "14px",
                padding: "8px 12px",
                lineHeight: "18px",
                opacity: editView ? 1 : 0.7,
              }}
              key={status.id}
              disabled={!editView}
            >
              {status.label_name}
            </Tag>
          ))
        ) : (
          <p>Loading...</p> // Optional loading state
        )}
      </div>

      {/* Details Section */}

      {/* Footer */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
        <Button onClick={closeModal} className="modal-cancel-btn">Cancel</Button>
        <Button type='primary' className="modal-success-btn" onClick={handleSubmitNew}>Save</Button>
      </div> */}
    </div>
  );
  const subTextStyle = { marginLeft: 30, color: "#555" };
  const iconStyle = { fontSize: 22, color: "#666", marginRight: 8 };
  // console.log(individualTask, "individualTask");

  return (
    <>
      <Modal
        title={editView ? `Edit ${eventData?.type}` : `View ${eventData?.type}`}
        open={isModalOpen}
        onCancel={closeModal}
        footer={false}
        maskClosable={false}
      >
        {!editView ? (
          <div>
            {/* Header Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <h3 level={4} style={{ textTransform: "capitalize" }}>
                {eventData?.type}
              </h3>
              <div>
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  // style={{ marginRight: 8 }}
                  onClick={handleEditOpen}
                  disabled={!individualTask}
                  style={{
                    display: `${
                      calendarData?.data?.calendar_data &&
                      calendarData?.data?.calendar_data[0].permission === "4" &&
                      coParentsMetaData?.user_as_coparent_couples &&
                      coParentsMetaData?.user_as_coparent_couples.length > 0
                        ? "none"
                        : ""
                    }`,
                    marginRight: 8,
                  }}
                >
                  Edit {eventData?.type}
                </Button>
                <Button
                  type="text"
                  icon={<DeleteOutlined style={{ color: "#9A4FE0" }} />}
                  className="add-task-checklist-btn"
                  onClick={manageDelete}
                  disabled={!individualTask}
                  style={{
                    display: `${
                      calendarData?.data?.calendar_data &&
                      calendarData?.data?.calendar_data[0].permission === "4" &&
                      coParentsMetaData?.user_as_coparent_couples &&
                      coParentsMetaData?.user_as_coparent_couples.length > 0
                        ? "none"
                        : ""
                    }`,
                  }}
                />
              </div>
            </div>

            {/* Task Name & Description */}
            <div>
              <Paragraph style={{ marginTop: "10px" }}>
                <strong>Task Name: </strong>
                {eventData?.title}
              </Paragraph>
            </div>
            <div>
              <Paragraph style={{ marginTop: "10px" }}>
                <strong>Description: </strong>
                {eventData?.description}
              </Paragraph>
            </div>

            <div>{/* <Text>{inputTextDesc}</Text> */}</div>

            <div>
              <Paragraph style={{ marginTop: "10px" }}>
                <strong>Location: </strong>
                {eventData?.location}
              </Paragraph>
            </div>
            {individualTask?.type === "event" &&
              individualTask?.checklist?.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  <h3 level={5}>Checklists</h3>

                  <List
                    dataSource={individualTask?.checklist} // Map over checklists array
                    renderItem={(item) => (
                      <List.Item
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        {/* <img src={CheckboxLogo} width={24} style={{ marginRight: "10px" }} /> */}
                        {item.title}
                      </List.Item>
                    )}
                  />
                </div>
              )}

            {/* Status & Priority */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }} level={5}>
                Status
              </h3>
              <Tag className="ant-tag-btn">{statusLabel}</Tag>
            </div>

            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }} level={5}>
                Preferred Display Name
              </h3>
              <Tag className="ant-tag-btn">{displayLabelId}</Tag>
            </div>

            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }} level={5}>
                Priority
              </h3>
              <Tag className="ant-tag-btn">{priorityLabel}</Tag>
            </div>

            {/* Task Details */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold" }} level={5}>
                Detail
              </h3>
              <List>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <AssignmentOutlined
                      style={{ marginRight: 8, fontSize: 16 }}
                    />
                    <Text strong>Assignees</Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {assignName.toString()}
                  </Text>
                </List.Item>
                {/* <List.Item style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                  <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <CalendarOutlined style={{ marginRight: 8, fontSize: 16 }} />
                    <Text strong>Colllaboration</Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>{collaboratorsName}</Text>
                </List.Item> */}
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <CalendarOutlined
                      style={{ marginRight: 8, fontSize: 16 }}
                    />
                    <Text strong>Date</Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {formattedDate}
                  </Text>
                </List.Item>

                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <ClockCircleOutlined
                      style={{ marginRight: 8, fontSize: 16 }}
                    />
                    <Text strong>Time</Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {individualTask?.start_time && individualTask?.end_time
                      ? `${moment
                          .utc(individualTask?.start_time)
                          .format("HH:mm")} - ${moment
                          .utc(individualTask?.end_time)
                          .format("HH:mm")}`
                      : "Not Set"}
                  </Text>
                </List.Item>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <BellOutlined style={{ marginRight: 8, fontSize: 16 }} />
                    <Text strong>
                      {" "}
                      <Text strong>Reminder: </Text>
                    </Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {descSelectedReminder === "No reminder"
                      ? "No Reminder"
                      : descSelectedReminder}
                  </Text>
                </List.Item>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <RepeatOutlined style={{ marginRight: 8 }} />
                    <Text strong>Repeat</Text>
                  </div>
                  {/* <Text style={{marginLeft: 26,  color: "#555" }}>{eventData.repeat_option ? eventData.repeat_option : "No Repeat"}</Text> */}
                  <Text style={subTextStyle}>
                    {eventData?.repeat_option
                      ? `${eventData.repeat_option
                          .charAt(0)
                          .toUpperCase()}${eventData.repeat_option.slice(1)}`
                      : "No Repeat"}{" "}
                    {eventData?.repetition_end_date &&
                      `(End until ${moment(
                        eventData.repetition_end_date
                      ).format("D, MMMM YYYY")})`}
                  </Text>
                </List.Item>

                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <ColorLensOutlined style={{ marginRight: 8 }} />
                    <Text strong>Colors: </Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {descSelectedColor}
                  </Text>
                </List.Item>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <ColorLensOutlined style={{ marginRight: 8 }} />
                    <Text strong>Notification: </Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {notificationText}
                  </Text>
                </List.Item>
              </List>
            </div>
          </div>
        ) : (
          <>
            <div>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <h3 level={4} style={{ textTransform: "capitalize" }}>
                    <EditOutlined /> Edit {eventData?.type}
                  </h3>
                  <div>
                    <Button className="reset-btn" onClick={handleviewOpen}>
                      Cancel
                    </Button>
                  </div>
                </div>
                <span style={{ fontSize: "16px", fontWeight: "600" }}>
                  Category
                </span>
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeTab}
                  className="custom-tabs"
                >
                  <Tabs.TabPane
                    tab={
                      <span>
                        <img src={taskicon} width={12} /> Task
                      </span>
                    }
                    key="1"
                  >
                    {taskContent}
                  </Tabs.TabPane>
                  <Tabs.TabPane
                    tab={
                      <span>
                        <img src={eventicon} width={12} /> Events
                      </span>
                    }
                    key="2"
                  >
                    {eventContent}
                  </Tabs.TabPane>
                </Tabs>
                <div className="details-container">
                  <h3 style={{ marginBottom: 5 }} className="details-title">
                    Detail
                  </h3>
                  <DetailsList
                    icon={<BellOutlined />}
                    title="Assign To"
                    description={assignName.toString() || "No users assigned"}
                    switchChecked={assignedUsers.length > 0}
                    onSwitchChange={() => setShowAssignModal(true)}
                    onClick={() => setShowAssignModal(true)}
                  />
                  {/* <DetailsList
        icon={<BellOutlined />}
        title="Collaboration"
        description={descSelectedCollaboration}
        switchChecked={switchStatesCollaboration}
        onSwitchChange={handleSwitchChangeCollaboration}
        onClick={() => setShowCollaborationModal(true)}
      /> */}
                  <DetailsList
                    icon={<CalendarOutlined />}
                    title="Date"
                    description={selectedDate ? selectedDate : formattedDate}
                    switchChecked={true}
                    onSwitchChange={() => handleSwitchChange()}
                    onClick={() => setShowModal(true)} // Open modal on click
                    required
                  />
                  <DetailsList
                    icon={<ClockCircleOutlined />}
                    title="Time"
                    description={
                      selectedTime?.start || selectedTime?.end
                        ? `${selectedTime.start || ""} - ${
                            selectedTime.end || ""
                          }`
                        : individualTask?.start_time && individualTask?.end_time
                        ? `${moment
                            .utc(individualTask.start_time)
                            .format("HH:mm")} - ${moment
                            .utc(individualTask.end_time)
                            .format("HH:mm")}`
                        : "Add time"
                    }
                    switchChecked={
                      selectedTime && selectedTime.start && selectedTime.end
                        ? true
                        : false
                    }
                    onSwitchChange={() => handleSwitchChangeTime()}
                    onClick={() => setShowTimeModal(true)}
                    required
                  />

                  <DetailsList
                    icon={<BellOutlined />}
                    title="Reminder"
                    description={
                      descSelectedReminder === "No reminder"
                        ? "No Reminder"
                        : descSelectedReminder
                    }
                    switchChecked={
                      descSelectedReminder === "No Reminder" ||
                      descSelectedReminder === "No reminder" ||
                      !descSelectedReminder
                        ? false
                        : true
                    }
                    onSwitchChange={() => handleSwitchChangeRem()}
                    onClick={() => setShowRemModal(true)}
                  />
                  {/* <DetailsList
        icon={<BellOutlined />}
        title="Repeat"
        description={eventData.repeat_option ? eventData.repeat_option : getRepeatDescription()}
        switchChecked={switchStatesRepeat}
        onSwitchChange={handleSwitchChangeRepeat}
        onClick={() => setShowRepeatModal(true)}
      /> */}
                  <DetailsList
                    icon={<RepeatOn />}
                    title="Repeat"
                    description={getRepeatDescription()}
                    switchChecked={switchStatesRepeat}
                    onSwitchChange={handleSwitchChangeRepeat}
                    onClick={() => setShowRepeatModal(true)}
                  />
                  <DetailsList
                    icon={<BellOutlined />}
                    title="Color"
                    description={descSelectedColor}
                    switchChecked={switchStatesColor}
                    onSwitchChange={() => handleSwitchChangeColor()}
                    onClick={() => setShowColorModal(true)}
                  />
                  <DetailsList
                    icon={<BellOutlined />}
                    title="Notification"
                    // description={descSelectedColor}
                    switchChecked={switchStatesNotification}
                    onSwitchChange={() => handleSwitchChangeNotification()}
                    onClick={() => handleSwitchChangeNotification()}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <Button onClick={closeModal} className="modal-cancel-btn">
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    className="modal-success-btn"
                    onClick={() =>
                      handleUpdateEvent(
                        eventData?.type,
                        eventData?.event_id || eventData?.task_id,
                        moment(selectedDate, "D, MMMM YYYY").format(
                          "YYYY-MM-DD"
                        )
                      )
                    }
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </Modal>
      <Modal
        title={`Delete ${eventData?.type === "event" ? "Event" : "Task"}`}
        open={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onOk={async () => {
          setShowDeleteModal(false);
          setIsDeleteModalVisible(true); // Open confirmation modal
        }}
        okText="Delete"
        okButtonProps={{ danger: true }}
      >
        <Radio.Group
          onChange={(e) => setDeleteType(e.target.value)}
          value={deleteType}
          style={{ display: "flex", flexDirection: "column", gap: 8 }}
        >
          <Radio value="current">
            This {eventData?.type === "event" ? "Event" : "Task"}
          </Radio>
          <Radio value="current_and_upcoming">
            This and following{" "}
            {eventData?.type === "event" ? "Events" : "Tasks"}
          </Radio>
          <Radio value="all">
            All {eventData?.type === "event" ? "Events" : "Tasks"}
          </Radio>
        </Radio.Group>
      </Modal>
      <div>
        {/* <DateCalender isOpen={isCalendarOpen} onClose={() => setIsCalendarOpen(false)} onSelectDate={handleSelectDate} /> */}
        <DateModalTask
          show={showModal}
          handleClose={() => setShowModal(false)}
          onDateSelect={handleDateSelect}
          selectedDate={
            moment(selectedDate, "D, MMMM YYYY").isValid()
              ? moment(selectedDate, "D, MMMM YYYY").toDate()
              : null
          }
        />
      </div>

      <div>
        <TimeSelect
          show={showTimeModal}
          handleClose={() => setShowTimeModal(false)}
          onSelectTime={handleSelectTime}
          selectedTime={selectedTime}
          selectedDate={selectedDate}
        />
      </div>
      <div>
        <Reminder
          show={showRemModal}
          handleClose={() => setShowRemModal(false)}
          onSelectReminder={handleSelectReminder}
          eventDate={selectedDate}
          eventTime={selectedTime}
          selectReminderTime={selectTextReminder}
          initialReminder={descSelectedReminder}
          eventData={eventData}
        />
        <AssignToModal
          visible={showAssignModal}
          onCancel={() => setShowAssignModal(false)}
          onSave={(newSelection) => {
            // console.log(newSelection, "newSelection");
            setUpdatedUsers(newSelection);
            setAssignedUsers(newSelection);

            const assignedNames = couples
              .flatMap((couple) => [couple.parent1, couple.parent2])
              .filter((parent) =>
                newSelection.some((sel) => sel.parent_id === parent.user_id)
              )
              .map((parent) => parent.nickname || parent.name || "Unknown")
              .filter((name) => name !== "Unknown");

            setAssignName(assignedNames.join(", "));
            setShowAssignModal(false);
          }}
          selectedUsers={
            eventData?.assignees || individualTask?.participants || []
          }
          selectedCoupleId={selectedCoupleId}
          couples={couples}
          users={userList}
        />
        <CollaborationModal
          visible={showCollaborationModal}
          onCancel={() => setShowCollaborationModal(false)}
          onSave={handleSaveCollaboration}
          collaborators={dummyCollaborators}
          selectedUsers={assignedUsers}
          selectedCoupleId={selectedCoupleId}
          couples={couples}
          initialSelected={selectedCollaborators}
        />
        <RepeatModal
          visible={showRepeatModal}
          onCancel={handleRepeatCancel}
          onSave={handleRepeatSave}
          initialValues={repeatConfig}
          repeatOption={repeatOption}
          adjustWeeknd={adjusWeekend}
          startDate={selectedDate} // 👈 This must be defined above this point
        />
        <ColorsModal
          metaData={metaData.colors}
          visible={showColorModal}
          onCancel={handleColorCancel}
          onSave={handleColorSave}
          initialValues={colorConfig}
          // selectedColorId={selectedColorId}
        />
        {isModalVisible && (
          <RecurringEventModal
            visible={isModalVisible}
            action="delete"
            occurrenceDate={selectedItemForDelete?.occurrenceDate}
            onClose={() => setIsModalVisible(false)}
            onConfirm={(type) => {
              // user chose delete type (all / this / future)
              setDeleteType(type);
              isModalVisible(false);
              isDeleteModalVisible(true); // now open confirmation modal
            }}
          />
        )}
        <RecurringEventModal
          visible={isUpdateModalVisible}
          action="update"
          occurrenceDate={selectedItemForDelete?.occurrenceDate}
          onClose={() => setIsUpdateModalVisible(false)}
          onConfirm={handleConfirmUpdate}
        />

        {isDeleteModalVisible && (
          <DeleteConfirmationModal
            visible={isDeleteModalVisible}
            onConfirm={async () => {
              await handleDeleteWithType(deleteType);
              setIsDeleteModalVisible(false);
            }}
            onCancel={() => setIsDeleteModalVisible(false)}
          />
        )}
      </div>
    </>
  );
};

export default ViewCoParentTask;
